import React, { useState } from "react";
import TextField from "../TextField/TextField";
import { FieldType, Unit } from "../../../services/helpers/types";
import SelectField from "../../molecules/SelectField/SelectField";
import { useTranslation } from "react-i18next";
import { getAddTextUnitField } from "./helpers";

interface AddTextFieldProps {
  field?: FieldType;
  onFieldChange: (name: string, value?: string) => void;
}

const AddTextField = (props: AddTextFieldProps) => {
  const { field, onFieldChange } = props;

  const { t } = useTranslation();

  const [defaultValue, setDefaultValue] = React.useState(
    field?.defaultValue ?? "",
  );

  const [unit, setUnit] = useState<Unit | undefined>(field?.unit ?? undefined);

  const handleSelectUnit = (value: string) => {
    setUnit(value as Unit);
    onFieldChange("unit", value);
  };

  const handleDefaultValueChange = (value: string) => {
    setDefaultValue(value);
    onFieldChange("defaultValue", value);
  };

  return (
    <>
      <div className="dui-example-field">
        <div className="dui-example-field-title">{t("defaultValue")}:</div>
        <TextField
          value={defaultValue}
          onChange={handleDefaultValueChange}
          placeholder={t("defaultValuePlaceholder")}
        />
      </div>
      <div className="dui-example-field">
        <div className="dui-example-field-title">{t("unit")}:</div>
        <SelectField
          value={unit}
          onChange={handleSelectUnit}
          field={getAddTextUnitField(t)}
        />
      </div>
    </>
  );
};

export default AddTextField;
